// extracted by mini-css-extract-plugin
export default {"ingrediensblock":"r7","heading":"s7","item":"t7","fadeIn":"u7","imagewrapper":"v7","modalheader":"w7","amount":"x7","name":"y7","desc":"z7","moredetails":"A7","ingheader":"B7"};
    if(module.hot) {
      // 1737143665018
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  